
<h1>Ingen tilgang</h1>

<p>Beklager, det oppsto en feil. <span class="click" (click)="logout()">Trykk her for å logge ut</span></p>    

